module.exports = __webpack_public_path__ + "assets/images/22e0bcdbc1cb733ee9af067045a78610.png";